import axiosIns from '@/api/axios'

// Updated to support pagination, filtering, and ordering
export const GET_COACHING = (args) => {
    return axiosIns.get('/master-data/coaching', { params: args });
}

// Legacy function for backward compatibility
export const GET_COACHING_BY_ID = (competencyId, args) => {
    return axiosIns.get(`/master-data/coaching/${competencyId}`, { params: args });
}

// New function to get coaching by competency
export const GET_COACHING_BY_COMPETENCY = (competencyId, args = {}) => {
    const params = {
        all: true,
        competency_id: competencyId,
        ...args
    };
    return axiosIns.get('/master-data/coaching', { params });
}


